import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import {
  ADMINISTRATIVE_INCIDENT_ENDPOINT,
  INCIDENT_RECORD_ENDPOINT,
} from '../../config/endpoints';
import { DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  ACTIVITY_ADMINISTRATIVE_INCIDENT,
  CLEAR_ADMINISTRATIVE_INCIDENTS,
  FLAG_GETTING_ADMINISTRATIVE_INCIDENTS,
  GET_ADMINISTRATIVE_INCIDENTS,
} from '../types/supervision-control';

const flagGettingAdministrativeIncidents = (flag) => (dispatch) =>
  dispatch({ type: FLAG_GETTING_ADMINISTRATIVE_INCIDENTS, payload: flag });

const getAdministrativeIncidents =
  ({ agencyId, dateString }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingAdministrativeIncidents(true));
      const query = QueryString.stringify({ agencyId, dateString });
      const url = `${ADMINISTRATIVE_INCIDENT_ENDPOINT}?${query}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_ADMINISTRATIVE_INCIDENTS, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingAdministrativeIncidents(false));
    }
  };

const clearAdministrativeIncidents = () => (dispatch) =>
  dispatch({ type: CLEAR_ADMINISTRATIVE_INCIDENTS });

const flagActivityAdministrativeIncident = (flag) => (dispatch) =>
  dispatch({ type: ACTIVITY_ADMINISTRATIVE_INCIDENT, payload: flag });

const postAdministrativeIncident =
  async ({
    incidentRecordType,
    incidentId,
    incidentSubtypeId,
    note,
    agencyId,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagActivityAdministrativeIncident(true));
      const body = JSON.stringify({
        incidentRecordType,
        incidentId,
        incidentSubtypeId,
        note,
        agencyId,
      });
      const response = await fetch(INCIDENT_RECORD_ENDPOINT, {
        ...DEFAULT_POST_CONFIG,
        body,
      });
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_ADMINISTRATIVE_INCIDENTS, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagActivityAdministrativeIncident(false));
    }
  };

export {
  getAdministrativeIncidents,
  clearAdministrativeIncidents,
  postAdministrativeIncident,
};
